module.exports = __webpack_public_path__ + "img/hotel.c135282a.png";